<template>
    <b-row>
        <b-col align="center" class="pmis-title">
            <h1>{{title}}</h1>
            <p id="pmis-subtitle">SRIP pametna mesta in skupnosti</p>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "PmisTitle",
        props: {
            title: String
        }
    }
</script>

<style lang="scss" scoped>
    .pmis-title {
        bottom: -4vh;
        height: 10px;
        z-index: 99;
    }

    #pmis-subtitle {
        color: $pmis-grey;
        letter-spacing: 2px;
    }
</style>
